<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="container">
    <a class="navbar-brand" href="#">Umyo Entertainment</a>

    <button class="navbar-toggler">
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
</nav>

<div class="emailContainer" style="margin-top: 80px; padding: 30px">
  <h1 class="heading">
    <i class="fas fa-check-circle icon"></i>
    Forgot Password
  </h1>
  <hr class="line" />
  <form [formGroup]="form">
    <div class="form-group">
      <input
        type="text"
        formControlName="email"
        class="form-control"
        placeholder="Enter Your Email Address"
      />
    </div>
    <div class="buttons">
      <button
        class="btn btn-primary rounded-corner mt-3"
        [disabled]="!form.valid"
        (click)="submit()"
      >
        Reset Password
      </button>
      <button class="btn btn-primary rounded-corner mt-3" (click)="login()">
        Goto Login
      </button>
    </div>
  </form>
</div>
